import { useState, useCallback } from 'react';

import useDebounce from './useDebounce';

interface SearchCompanyState {
  searchQuery: string;
  companyName: string | undefined;
  showResultsInSpotlight: boolean;
}

export function useSearchCompanyState({ defaultCompanyName }: { defaultCompanyName?: string }) {
  const [state, setState] = useState<SearchCompanyState>({
    searchQuery: '',
    companyName: defaultCompanyName ?? undefined,
    showResultsInSpotlight: false,
  });

  const debouncedSearchValue = useDebounce(state.searchQuery);

  const setSearchQuery = useCallback((value: string) => {
    setState((prev) => ({
      ...prev,
      searchQuery: value,
      companyName: undefined,
    }));
  }, []);

  const setCompanyName = useCallback((value: string) => {
    setState((prev) => ({
      ...prev,
      companyName: value,
    }));
  }, []);

  const setShowResultsInSpotlight = useCallback((value: boolean) => {
    setState((prev) => ({
      ...prev,
      showResultsInSpotlight: value,
    }));
  }, []);

  return {
    ...state,
    debouncedSearchValue,
    setSearchQuery,
    setCompanyName,
    setShowResultsInSpotlight,
  };
}
